import { EPButton } from '../common/EPButton';
import { Subtitle, Title } from '../common/Headlines';
import { type TranslationKey, useTranslations } from '../intl/useTranslations';
import { ContentBox } from '../layout/ContentBox';
import { Layout } from '../layout/Layout';
import { getConsentChallenge } from '../store/challenges';
import { getServerSideErrorDescription, getServerSideErrors } from '../store/error';
import { getUrlToEduplaces } from '../store/route';

export function ErrorPage() {
  const t = useTranslations('error');
  const error = getServerSideErrors() && t(getServerSideErrors() as TranslationKey<'error'>);
  const description = getServerSideErrorDescription();
  const consentChallenge = getConsentChallenge();
  const urlToEduplaces = getUrlToEduplaces();

  return (
    <Layout className="flex items-center justify-center">
      <ContentBox className="flex max-w-prose flex-col gap-8 overflow-hidden">
        <div className="flex flex-col gap-2">
          <Title>{t('title')}</Title>
          <Subtitle>{error ?? t('unknown_error')}</Subtitle>
          {!error && (
            <div className="text-sm text-white md:text-epspacedust">
              {t('unknown_error_send_help')}
            </div>
          )}
        </div>

        {description && <div className="text-sm text-white md:text-epspacedust">{description}</div>}
        {!error && (
          <div className="text-[0.6rem] text-white md:text-epspacedust">
            {navigator.userAgent}
            <br />
            {new Date().toISOString()}
            <br />
            {window.location.host + window.location.pathname}
          </div>
        )}

        <form className="flex flex-col gap-3 md:flex-row" action="/error/reject" method="post">
          {consentChallenge && (
            <>
              <input type="hidden" name="consent_challenge" value={consentChallenge} />
              <EPButton className="grow justify-center max-md:hidden" element="submit">
                {t('back_to_app')}
              </EPButton>
              <EPButton
                className="grow justify-center from-white to-white md:hidden"
                element="submit"
                textColorClassName="text-epspacedust hover:text-white"
              >
                {t('back_to_app')}
              </EPButton>
            </>
          )}
          <EPButton
            href={urlToEduplaces}
            element="a"
            mode="tertiary"
            className="grow justify-center max-md:hidden"
          >
            {t('back_to_eduplaces')}
          </EPButton>
          <EPButton
            href={urlToEduplaces}
            element="a"
            mode="ghost"
            className="grow justify-center md:hidden"
            textColorClassName="text-white hover:text-epspacedust"
          >
            {t('back_to_eduplaces')}
          </EPButton>
        </form>
      </ContentBox>
    </Layout>
  );
}
